import i18n from '@/utils/i18n';
import moment from 'moment-timezone';
import React, { useMemo } from 'react';
import { formatSummaryDate } from '@/utils/date';
import { getTrueTime } from '@/utils/true-time';
import { PrebookConfig } from '@/contexts/item-context-types';
import { StatusLabel } from './status-label';
import { StyleProp, ViewStyle } from 'react-native';
import { useNewOrderContext } from '@/contexts/new-order-context';

interface Props {
  compact?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  prebookConfig: PrebookConfig;
}

export const PrebookLabel: React.FC<Props> = ({
  compact = false,
  containerStyle,
  prebookConfig,
}) => {
  const { supplierTimezone } = useNewOrderContext();

  const displayText = useMemo(() => {
    const nowMoment = moment(getTrueTime()).tz(supplierTimezone);
    const momentFrom = moment(prebookConfig.order_from).startOf('day');
    const momentUntil = moment(prebookConfig.order_until).endOf('day');

    if (nowMoment.isBefore(momentFrom)) {
      return i18n.t('prebook.starts', { date: formatSummaryDate(momentFrom) });
    } else if (nowMoment.isAfter(momentUntil)) {
      return i18n.t('prebook.closed');
    } else if (momentUntil.diff(nowMoment, 'day') > 1) {
      return i18n.t('prebook.ends', {
        date: formatSummaryDate(momentUntil),
      });
    }
    return i18n.t('prebook.ends_today');
  }, [prebookConfig, supplierTimezone]);

  return (
    <StatusLabel
      compact={compact}
      containerStyle={containerStyle}
      testID="prebook-label"
      text={displayText}
    />
  );
};
